// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import CompetitionSurvey from "./competition-survey.js"
import Element from "./element.js"
import RequiredMetadatum from "./required-metadatum.js"
import Step from "./step.js"
import TeamSurvey from "./team-survey.js"

const modelClassData = {
  "attributes": {
    "activated": {
      "column": null,
      "name": "activated",
      "selected_by_default": null,
      "translated": null
    },
    "allow_editing_finished_team_surveys": {
      "column": {
        "default": false,
        "name": "allow_editing_finished_team_surveys",
        "null": false,
        "type": "boolean"
      },
      "name": "allow_editing_finished_team_surveys",
      "selected_by_default": null,
      "translated": null
    },
    "allow_multiple_takes": {
      "column": {
        "default": false,
        "name": "allow_multiple_takes",
        "null": false,
        "type": "boolean"
      },
      "name": "allow_multiple_takes",
      "selected_by_default": null,
      "translated": null
    },
    "allow_sign_out": {
      "column": {
        "default": true,
        "name": "allow_sign_out",
        "null": false,
        "type": "boolean"
      },
      "name": "allow_sign_out",
      "selected_by_default": null,
      "translated": null
    },
    "authenticate_anonymously": {
      "column": {
        "default": false,
        "name": "authenticate_anonymously",
        "null": false,
        "type": "boolean"
      },
      "name": "authenticate_anonymously",
      "selected_by_default": null,
      "translated": null
    },
    "authenticate_with_uni_c": {
      "column": {
        "default": true,
        "name": "authenticate_with_uni_c",
        "null": false,
        "type": "boolean"
      },
      "name": "authenticate_with_uni_c",
      "selected_by_default": null,
      "translated": null
    },
    "authenticate_with_email": {
      "column": {
        "default": true,
        "name": "authenticate_with_email",
        "null": false,
        "type": "boolean"
      },
      "name": "authenticate_with_email",
      "selected_by_default": null,
      "translated": null
    },
    "cannot_be_taken_anonymously": {
      "column": {
        "default": false,
        "name": "cannot_be_taken_anonymously",
        "null": false,
        "type": "boolean"
      },
      "name": "cannot_be_taken_anonymously",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "anonymize_answers_after_days": {
      "column": {
        "default": null,
        "name": "anonymize_answers_after_days",
        "null": true,
        "type": "integer"
      },
      "name": "anonymize_answers_after_days",
      "selected_by_default": null,
      "translated": null
    },
    "description": {
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "text"
      },
      "name": "description",
      "selected_by_default": null,
      "translated": null
    },
    "editable_answers": {
      "column": {
        "default": true,
        "name": "editable_answers",
        "null": false,
        "type": "boolean"
      },
      "name": "editable_answers",
      "selected_by_default": null,
      "translated": null
    },
    "feedback_empty_answers": {
      "column": {
        "default": false,
        "name": "feedback_empty_answers",
        "null": false,
        "type": "boolean"
      },
      "name": "feedback_empty_answers",
      "selected_by_default": null,
      "translated": null
    },
    "globally_accessible": {
      "column": {
        "default": true,
        "name": "globally_accessible",
        "null": false,
        "type": "boolean"
      },
      "name": "globally_accessible",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "members_can_start_steps": {
      "column": {
        "default": true,
        "name": "members_can_start_steps",
        "null": false,
        "type": "boolean"
      },
      "name": "members_can_start_steps",
      "selected_by_default": null,
      "translated": null
    },
    "members_follow_team_captain": {
      "column": {
        "default": false,
        "name": "members_follow_team_captain",
        "null": false,
        "type": "boolean"
      },
      "name": "members_follow_team_captain",
      "selected_by_default": null,
      "translated": null
    },
    "must_be_taken_anonymously": {
      "column": {
        "default": false,
        "name": "must_be_taken_anonymously",
        "null": false,
        "type": "boolean"
      },
      "name": "must_be_taken_anonymously",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "only_owner_can_start": {
      "column": {
        "default": false,
        "name": "only_owner_can_start",
        "null": false,
        "type": "boolean"
      },
      "name": "only_owner_can_start",
      "selected_by_default": null,
      "translated": null
    },
    "redirectable": {
      "column": null,
      "name": "redirectable",
      "selected_by_default": null,
      "translated": null
    },
    "redirect_survey_id": {
      "column": {
        "default": null,
        "name": "redirect_survey_id",
        "null": true,
        "type": "uuid"
      },
      "name": "redirect_survey_id",
      "selected_by_default": null,
      "translated": null
    },
    "redirect_timeout": {
      "column": {
        "default": null,
        "name": "redirect_timeout",
        "null": true,
        "type": "integer"
      },
      "name": "redirect_timeout",
      "selected_by_default": null,
      "translated": null
    },
    "redirect_text": {
      "column": {
        "default": null,
        "name": "redirect_text",
        "null": true,
        "type": "text"
      },
      "name": "redirect_text",
      "selected_by_default": null,
      "translated": null
    },
    "redirect_url": {
      "column": {
        "default": null,
        "name": "redirect_url",
        "null": true,
        "type": "string"
      },
      "name": "redirect_url",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "deactivated",
        "name": "state",
        "null": true,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "steps_count": {
      "column": {
        "default": 0,
        "name": "steps_count",
        "null": false,
        "type": "integer"
      },
      "name": "steps_count",
      "selected_by_default": null,
      "translated": null
    },
    "team_access": {
      "column": {
        "default": "only_owner",
        "name": "team_access",
        "null": false,
        "type": "string"
      },
      "name": "team_access",
      "selected_by_default": null,
      "translated": null
    },
    "team_surveys_count": {
      "column": {
        "default": 0,
        "name": "team_surveys_count",
        "null": false,
        "type": "integer"
      },
      "name": "team_surveys_count",
      "selected_by_default": null,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": null,
      "translated": null
    },
    "visible": {
      "column": {
        "default": true,
        "name": "visible",
        "null": false,
        "type": "boolean"
      },
      "name": "visible",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "next_button_image_path": {
      "column": null,
      "name": "next_button_image_path",
      "selected_by_default": false,
      "translated": null
    },
    "finish_button_image_path": {
      "column": null,
      "name": "finish_button_image_path",
      "selected_by_default": false,
      "translated": null
    },
    "needs_feedback": {
      "column": null,
      "name": "needs_feedback",
      "selected_by_default": false,
      "translated": null
    },
    "sign_in_image_path": {
      "column": null,
      "name": "sign_in_image_path",
      "selected_by_default": false,
      "translated": null
    },
    "start_button_image_path": {
      "column": null,
      "name": "start_button_image_path",
      "selected_by_default": false,
      "translated": null
    },
    "start_feedback_button_image_path": {
      "column": null,
      "name": "start_feedback_button_image_path",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Survey",
  "collectionKey": "surveys",
  "collectionName": "surveys",
  "i18nKey": "survey",
  "camelizedLower": "survey",
  "name": "Survey",
  "nameDasherized": "survey",
  "pluralName": "surveys",
  "ransackable_associations": [
    {
      "className": "CompetitionSurvey",
      "collectionName": "competition_surveys",
      "foreignKey": "survey_id",
      "name": "competition_surveys",
      "macro": "has_many",
      "resource_name": "CompetitionSurvey",
      "through": null
    },
    {
      "className": "Element",
      "collectionName": "elements",
      "foreignKey": "step_id",
      "name": "elements",
      "macro": "has_many",
      "resource_name": "Element",
      "through": "steps"
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "finish_button_image_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "finish_button_image_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "finish_button_image_attachment"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "next_button_image_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "next_button_image_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "next_button_image_attachment"
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "redirect_survey_id",
      "name": "redirect_survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "redirect_survey_id",
      "name": "redirected_surveys",
      "macro": "has_many",
      "resource_name": "Survey",
      "through": null
    },
    {
      "className": "RequiredMetadatum",
      "collectionName": "required_metadata",
      "foreignKey": "resource_id",
      "name": "required_metadatum",
      "macro": "has_one",
      "resource_name": "RequiredMetadatum",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "sign_in_image_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "sign_in_image_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "sign_in_image_attachment"
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "start_button_image_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "start_button_image_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "start_button_image_attachment"
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "start_feedback_button_image_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "start_feedback_button_image_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "start_feedback_button_image_attachment"
    },
    {
      "className": "Step",
      "collectionName": "steps",
      "foreignKey": "survey_id",
      "name": "steps",
      "macro": "has_many",
      "resource_name": "Step",
      "through": null
    },
    {
      "className": "SurveyJudge",
      "collectionName": "survey_judges",
      "foreignKey": "survey_id",
      "name": "survey_judges",
      "macro": "has_many",
      "resource_name": "SurveyJudge",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "survey_id",
      "name": "team_surveys",
      "macro": "has_many",
      "resource_name": "TeamSurvey",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "allow_editing_finished_team_surveys",
      "column": {
        "default": false,
        "name": "allow_editing_finished_team_surveys",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "allow_multiple_takes",
      "column": {
        "default": false,
        "name": "allow_multiple_takes",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "allow_sign_out",
      "column": {
        "default": true,
        "name": "allow_sign_out",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "anonymize_answers_after_days",
      "column": {
        "default": null,
        "name": "anonymize_answers_after_days",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "authenticate_anonymously",
      "column": {
        "default": false,
        "name": "authenticate_anonymously",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "authenticate_with_email",
      "column": {
        "default": true,
        "name": "authenticate_with_email",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "authenticate_with_uni_c",
      "column": {
        "default": true,
        "name": "authenticate_with_uni_c",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "cannot_be_taken_anonymously",
      "column": {
        "default": false,
        "name": "cannot_be_taken_anonymously",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "description",
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "editable_answers",
      "column": {
        "default": true,
        "name": "editable_answers",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "feedback_empty_answers",
      "column": {
        "default": false,
        "name": "feedback_empty_answers",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "globally_accessible",
      "column": {
        "default": true,
        "name": "globally_accessible",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "members_can_start_steps",
      "column": {
        "default": true,
        "name": "members_can_start_steps",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "members_follow_team_captain",
      "column": {
        "default": false,
        "name": "members_follow_team_captain",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "must_be_taken_anonymously",
      "column": {
        "default": false,
        "name": "must_be_taken_anonymously",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_redirect_survey_id",
      "column": {
        "default": null,
        "name": "old_redirect_survey_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "only_owner_can_start",
      "column": {
        "default": false,
        "name": "only_owner_can_start",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "redirect_survey_id",
      "column": {
        "default": null,
        "name": "redirect_survey_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "redirect_text",
      "column": {
        "default": null,
        "name": "redirect_text",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "redirect_timeout",
      "column": {
        "default": null,
        "name": "redirect_timeout",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "redirect_url",
      "column": {
        "default": null,
        "name": "redirect_url",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "deactivated",
        "name": "state",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "steps_count",
      "column": {
        "default": 0,
        "name": "steps_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "team_access",
      "column": {
        "default": "only_owner",
        "name": "team_access",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "team_surveys_count",
      "column": {
        "default": 0,
        "name": "team_surveys_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "visible",
      "column": {
        "default": true,
        "name": "visible",
        "null": false,
        "type": "boolean"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "CompetitionSurvey",
      "collectionName": "competition_surveys",
      "foreignKey": "survey_id",
      "name": "competition_surveys",
      "macro": "has_many",
      "resource_name": "CompetitionSurvey",
      "through": null
    },
    {
      "className": "Element",
      "collectionName": "elements",
      "foreignKey": "step_id",
      "name": "elements",
      "macro": "has_many",
      "resource_name": "Element",
      "through": "steps"
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "redirect_survey_id",
      "name": "redirect_survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    },
    {
      "className": "RequiredMetadatum",
      "collectionName": "required_metadata",
      "foreignKey": "resource_id",
      "name": "required_metadatum",
      "macro": "has_one",
      "resource_name": "RequiredMetadatum",
      "through": null
    },
    {
      "className": "Step",
      "collectionName": "steps",
      "foreignKey": "survey_id",
      "name": "steps",
      "macro": "has_many",
      "resource_name": "Step",
      "through": null
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "survey_id",
      "name": "team_surveys",
      "macro": "has_many",
      "resource_name": "TeamSurvey",
      "through": null
    }
  ],
  "paramKey": "survey",
  "primaryKey": "id"
}

/** Frontend model for Survey. */
export default class Survey extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  activated() {
    return this.readAttributeUnderscore("activated")
  }

  /** @returns {boolean} */
  hasActivated() {
    const value = this.activated()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  allowEditingFinishedTeamSurveys() {
    return this.readAttributeUnderscore("allow_editing_finished_team_surveys")
  }

  /** @returns {boolean} */
  hasAllowEditingFinishedTeamSurveys() {
    const value = this.allowEditingFinishedTeamSurveys()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  allowMultipleTakes() {
    return this.readAttributeUnderscore("allow_multiple_takes")
  }

  /** @returns {boolean} */
  hasAllowMultipleTakes() {
    const value = this.allowMultipleTakes()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  allowSignOut() {
    return this.readAttributeUnderscore("allow_sign_out")
  }

  /** @returns {boolean} */
  hasAllowSignOut() {
    const value = this.allowSignOut()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  authenticateAnonymously() {
    return this.readAttributeUnderscore("authenticate_anonymously")
  }

  /** @returns {boolean} */
  hasAuthenticateAnonymously() {
    const value = this.authenticateAnonymously()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  authenticateWithUniC() {
    return this.readAttributeUnderscore("authenticate_with_uni_c")
  }

  /** @returns {boolean} */
  hasAuthenticateWithUniC() {
    const value = this.authenticateWithUniC()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  authenticateWithEmail() {
    return this.readAttributeUnderscore("authenticate_with_email")
  }

  /** @returns {boolean} */
  hasAuthenticateWithEmail() {
    const value = this.authenticateWithEmail()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  cannotBeTakenAnonymously() {
    return this.readAttributeUnderscore("cannot_be_taken_anonymously")
  }

  /** @returns {boolean} */
  hasCannotBeTakenAnonymously() {
    const value = this.cannotBeTakenAnonymously()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  anonymizeAnswersAfterDays() {
    return this.readAttributeUnderscore("anonymize_answers_after_days")
  }

  /** @returns {boolean} */
  hasAnonymizeAnswersAfterDays() {
    const value = this.anonymizeAnswersAfterDays()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  description() {
    return this.readAttributeUnderscore("description")
  }

  /** @returns {boolean} */
  hasDescription() {
    const value = this.description()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  editableAnswers() {
    return this.readAttributeUnderscore("editable_answers")
  }

  /** @returns {boolean} */
  hasEditableAnswers() {
    const value = this.editableAnswers()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  feedbackEmptyAnswers() {
    return this.readAttributeUnderscore("feedback_empty_answers")
  }

  /** @returns {boolean} */
  hasFeedbackEmptyAnswers() {
    const value = this.feedbackEmptyAnswers()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  globallyAccessible() {
    return this.readAttributeUnderscore("globally_accessible")
  }

  /** @returns {boolean} */
  hasGloballyAccessible() {
    const value = this.globallyAccessible()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  membersCanStartSteps() {
    return this.readAttributeUnderscore("members_can_start_steps")
  }

  /** @returns {boolean} */
  hasMembersCanStartSteps() {
    const value = this.membersCanStartSteps()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  membersFollowTeamCaptain() {
    return this.readAttributeUnderscore("members_follow_team_captain")
  }

  /** @returns {boolean} */
  hasMembersFollowTeamCaptain() {
    const value = this.membersFollowTeamCaptain()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  mustBeTakenAnonymously() {
    return this.readAttributeUnderscore("must_be_taken_anonymously")
  }

  /** @returns {boolean} */
  hasMustBeTakenAnonymously() {
    const value = this.mustBeTakenAnonymously()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  onlyOwnerCanStart() {
    return this.readAttributeUnderscore("only_owner_can_start")
  }

  /** @returns {boolean} */
  hasOnlyOwnerCanStart() {
    const value = this.onlyOwnerCanStart()

    return this._isPresent(value)
  }

  /** @returns {any} */
  redirectable() {
    return this.readAttributeUnderscore("redirectable")
  }

  /** @returns {boolean} */
  hasRedirectable() {
    const value = this.redirectable()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  redirectSurveyId() {
    return this.readAttributeUnderscore("redirect_survey_id")
  }

  /** @returns {boolean} */
  hasRedirectSurveyId() {
    const value = this.redirectSurveyId()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  redirectTimeout() {
    return this.readAttributeUnderscore("redirect_timeout")
  }

  /** @returns {boolean} */
  hasRedirectTimeout() {
    const value = this.redirectTimeout()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  redirectText() {
    return this.readAttributeUnderscore("redirect_text")
  }

  /** @returns {boolean} */
  hasRedirectText() {
    const value = this.redirectText()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  redirectUrl() {
    return this.readAttributeUnderscore("redirect_url")
  }

  /** @returns {boolean} */
  hasRedirectUrl() {
    const value = this.redirectUrl()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {number} */
  stepsCount() {
    return this.readAttributeUnderscore("steps_count")
  }

  /** @returns {boolean} */
  hasStepsCount() {
    const value = this.stepsCount()

    return this._isPresent(value)
  }

  /** @returns {string} */
  teamAccess() {
    return this.readAttributeUnderscore("team_access")
  }

  /** @returns {boolean} */
  hasTeamAccess() {
    const value = this.teamAccess()

    return this._isPresent(value)
  }

  /** @returns {number} */
  teamSurveysCount() {
    return this.readAttributeUnderscore("team_surveys_count")
  }

  /** @returns {boolean} */
  hasTeamSurveysCount() {
    const value = this.teamSurveysCount()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  visible() {
    return this.readAttributeUnderscore("visible")
  }

  /** @returns {boolean} */
  hasVisible() {
    const value = this.visible()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nextButtonImagePath() {
    return this.readAttributeUnderscore("next_button_image_path")
  }

  /** @returns {boolean} */
  hasNextButtonImagePath() {
    const value = this.nextButtonImagePath()

    return this._isPresent(value)
  }

  /** @returns {any} */
  finishButtonImagePath() {
    return this.readAttributeUnderscore("finish_button_image_path")
  }

  /** @returns {boolean} */
  hasFinishButtonImagePath() {
    const value = this.finishButtonImagePath()

    return this._isPresent(value)
  }

  /** @returns {any} */
  needsFeedback() {
    return this.readAttributeUnderscore("needs_feedback")
  }

  /** @returns {boolean} */
  hasNeedsFeedback() {
    const value = this.needsFeedback()

    return this._isPresent(value)
  }

  /** @returns {any} */
  signInImagePath() {
    return this.readAttributeUnderscore("sign_in_image_path")
  }

  /** @returns {boolean} */
  hasSignInImagePath() {
    const value = this.signInImagePath()

    return this._isPresent(value)
  }

  /** @returns {any} */
  startButtonImagePath() {
    return this.readAttributeUnderscore("start_button_image_path")
  }

  /** @returns {boolean} */
  hasStartButtonImagePath() {
    const value = this.startButtonImagePath()

    return this._isPresent(value)
  }

  /** @returns {any} */
  startFeedbackButtonImagePath() {
    return this.readAttributeUnderscore("start_feedback_button_image_path")
  }

  /** @returns {boolean} */
  hasStartFeedbackButtonImagePath() {
    const value = this.startFeedbackButtonImagePath()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  activate(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "activate",
        primaryKey: this.primaryKey(),
        collectionName: "surveys",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  countTeamSurveys(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "count_team_surveys",
        primaryKey: this.primaryKey(),
        collectionName: "surveys",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  createTeamSurvey(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "create_team_survey",
        primaryKey: this.primaryKey(),
        collectionName: "surveys",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  deactivate(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "deactivate",
        primaryKey: this.primaryKey(),
        collectionName: "surveys",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  duplicate(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "duplicate",
        primaryKey: this.primaryKey(),
        collectionName: "surveys",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  recursiveRedirectSurvey(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "recursive_redirect_survey",
        primaryKey: this.primaryKey(),
        collectionName: "surveys",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  sortSteps(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "sort_steps",
        primaryKey: this.primaryKey(),
        collectionName: "surveys",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./competition-survey.js").default>} */
  competitionSurveys() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["survey_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "competition_surveys",
        model: this,
        modelClass: CompetitionSurvey
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./competition-survey.js").default>>} */
  loadCompetitionSurveys() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["survey_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "competition_surveys",
        model: this,
        modelClass: CompetitionSurvey
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./competition-survey.js").default>>} */
  ensureCompetitionSurveysLoaded() {
    return this.ensureAssociationLoaded("competition_surveys")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./element.js").default>} */
  elements() {
    return new Collection(
      {
        reflectionName: "elements",
        model: this,
        modelClass: Element
      },
      {
        params: {
          through: {
            model: "Survey",
            id: this.primaryKey(),
            reflection: "elements"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./element.js").default>>} */
  loadElements() {
    return this._loadHasManyReflection(
      {
        reflectionName: "elements",
        model: this,
        modelClass: Element
      },
      {
        params: {
          through: {
            model: "Survey",
            id: this.primaryKey(),
            reflection: "elements"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./element.js").default>>} */
  ensureElementsLoaded() {
    return this.ensureAssociationLoaded("elements")
  }

  /** @returns {import("./survey.js").default | null} */
  redirectSurvey() {
    return this._readBelongsToReflection({modelClass: Survey, reflectionName: "redirect_survey"})
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  loadRedirectSurvey() {
    if (!("redirectSurveyId" in this)) throw new Error("Foreign key method wasn't defined: redirectSurveyId")

    const id = this.redirectSurveyId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "redirect_survey",
        model: this,
        modelClass: Survey
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  ensureRedirectSurveyLoaded() {
    return this.ensureAssociationLoaded("redirect_survey")
  }

  /** @returns {import("./required-metadatum.js").default | null} */
  requiredMetadatum() {
    return this._readHasOneReflection({modelClass: RequiredMetadatum, reflectionName: "required_metadatum"})
  }

  /** @returns {Promise<import("./required-metadatum.js").default | null>} */
  loadRequiredMetadatum() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["resource_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "required_metadatum",
        model: this,
        modelClass: RequiredMetadatum
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./required-metadatum.js").default | null>} */
  ensureRequiredMetadatumLoaded() {
    return this.ensureAssociationLoaded("required_metadatum")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./step.js").default>} */
  steps() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["survey_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "steps",
        model: this,
        modelClass: Step
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./step.js").default>>} */
  loadSteps() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["survey_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "steps",
        model: this,
        modelClass: Step
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./step.js").default>>} */
  ensureStepsLoaded() {
    return this.ensureAssociationLoaded("steps")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./team-survey.js").default>} */
  teamSurveys() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["survey_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "team_surveys",
        model: this,
        modelClass: TeamSurvey
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./team-survey.js").default>>} */
  loadTeamSurveys() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["survey_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "team_surveys",
        model: this,
        modelClass: TeamSurvey
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./team-survey.js").default>>} */
  ensureTeamSurveysLoaded() {
    return this.ensureAssociationLoaded("team_surveys")
  }
}
